(function () {
  function ready(fn) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 200);
    }
  }

  function init() {
    var dataEl = document.getElementById('chv-tooltip-data');
    if (!dataEl) return;

    var terms;
    try {
      terms = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!terms || !terms.length) return;

    terms.sort(function (a, b) { return b.term.length - a.term.length; });

    var escaped = terms.map(function (t) {
      return t.term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    var pattern = new RegExp('\\b(' + escaped.join('|') + ')\\b', 'i');

    var termMap = {};
    terms.forEach(function (t) {
      termMap[t.term.toLowerCase()] = t.definition;
    });

    var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, A: 1, H1: 1, H2: 1, H3: 1 };

    var containers = document.querySelectorAll('[class*="#rte"], [class*="collection-filter-item-value"], [class*="collection-filter-header-heading"]');
    containers.forEach(applyTooltip);

    function applyTooltip(container) {
      var matchedTerms = {};
      var matchedCount = 0;
      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          var parent = node.parentElement;
          if (!parent || SKIP_TAGS[parent.tagName]) return NodeFilter.FILTER_REJECT;
          if (parent.closest('.chv-tooltip')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      var node;
      while (matchedCount < terms.length && (node = walker.nextNode())) {
        var match = pattern.exec(node.textContent);
        if (match) {
          var key = match[0].toLowerCase();
          if (!matchedTerms[key]) {
            matchedTerms[key] = true;
            matchedCount++;
            var afterNode = wrapMatch(node, match);
            walker.currentNode = afterNode; // resume scanning right after the inserted span
          }
        }
      }
    }

    function positionBubble(span, bubble) {
      var rect = span.getBoundingClientRect();
      var bubbleHeight = bubble.offsetHeight || 40;
      var top = rect.top - bubbleHeight - 6;
      if (top < 4) {
        top = rect.bottom + 6; // not enough room above, show below instead
      }
      var left = rect.left;
      var maxLeft = window.innerWidth - 260 - 8;
      if (left > maxLeft) left = Math.max(8, maxLeft);
      bubble.style.top = top + 'px';
      bubble.style.left = left + 'px';
    }

    function wrapMatch(node, match) {
      var text = node.textContent;
      var start = match.index;
      var end = start + match[0].length;

      var before = document.createTextNode(text.slice(0, start));
      var after = document.createTextNode(text.slice(end));

      var span = document.createElement('span');
      span.className = 'chv-tooltip';
      span.tabIndex = 0;
      span.setAttribute('role', 'button');
      span.textContent = match[0];

      var bubble = document.createElement('span');
      bubble.className = 'chv-tooltip-bubble';
      bubble.setAttribute('role', 'tooltip');
      bubble.textContent = termMap[match[0].toLowerCase()] || '';
      span.appendChild(bubble);

      span.addEventListener('mouseenter', function () { positionBubble(span, bubble); });
      span.addEventListener('focus', function () { positionBubble(span, bubble); });

      span.addEventListener('click', function (e) {
        e.stopPropagation();
        positionBubble(span, bubble);
        var isActive = span.classList.contains('is-active');
        document.querySelectorAll('.chv-tooltip.is-active').forEach(function (el) {
          el.classList.remove('is-active');
        });
        if (!isActive) span.classList.add('is-active');
      });

      var parent = node.parentNode;
      parent.insertBefore(before, node);
      parent.insertBefore(span, node);
      parent.insertBefore(after, node);
      parent.removeChild(node);
      return after;
    }

    document.addEventListener('click', function () {
      document.querySelectorAll('.chv-tooltip.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
    });
  }

  ready(init);
})();